var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.Utilities = OCS.Interfaces.Utilities || {};
OCS.Interfaces.Utilities.color = {
    hex_cache: {},
    /**
     * Converts HEXA (HEX + Alpha) to RGBA (Red/Green/Blue/Alpha)
     *
     * @method hexa2rgba
     * @param hex {string} HEXA value to convert to RGBA
     */
    hexa2rgba: function (hex) {
        if (!this.hex_cache[hex]) {
            var rgba = hex.replace('#', '').match(/(.{2})/g);

            var i = 4;
            while (i--) {
                rgba[i] = parseInt(rgba[i], 16);
            }

            var alpha = rgba[3]; 	//if we want to use this function to convert alpha values as well, use this line.
            //alpha = 1; 								//if we want to just have alpha set at 1, use this function
            rgba.splice(3, 1);
            this.hex_cache[hex] = {'red': rgba[0], 'green': rgba[1], 'blue': rgba[2], 'alpha': alpha};
        }
        return this.hex_cache[hex];
    }, //hexa2rgba
    /**
     * Converts HEX to RGB (Red/Green/Blue)
     *
     * @method hex2rgb
     * @param hex {string} HEX value to convert to RGB
     */
    hex2rgb: function (hex) {
        var rgb = hex.replace('#', '').match(/(.{2})/g);

        var i = 3;
        while (i--) {
            rgb[i] = parseInt(rgb[i], 16);
        }

        return {'red': rgb[0], 'green': rgb[1], 'blue': rgb[2]};
    }, //hex2rgb

    /**
     * Converts HEX to RGB (Red/Green/Blue)
     *
     * @method hexo2rgb
     * @param hex {string} HEX value to convert to RGB
     */
    hexo2rgba: function (hex, opacity) {
        var rgb = hex.replace('#', '').match(/(.{2})/g);
        var i;
        if (rgb.length && rgb.length <= 4) {
            i = rgb.length;
        } else {
            i = 3;
        }
        while (i--) {
            rgb[i] = parseInt(rgb[i], 16);
        }
        if (this.isNumber(rgb[3]) && !this.isNumber(opacity)) {
            opacity = rgb[3];
        }
        if (!this.isNumber(opacity)) {
            opacity = 0;
        }

        return {'red': rgb[0], 'green': rgb[1], 'blue': rgb[2], 'alpha': opacity};
    }, //hexo2rgb

    hexa2rgbaString: function (hex) {
        var rgba_obj = this.hexa2rgba(hex);
        if (isNaN(rgba_obj.alpha) || !this.isNumber(rgba_obj.alpha)) {
            rgba_obj.alpha = 255;
        }
        var rgba_str = String("rgba({0}, {1}, {2}, {3})").format(rgba_obj.red, rgba_obj.green, rgba_obj.blue, rgba_obj.alpha);
        return rgba_str;
    },
    /**
     * Converts hex to rgb (Red/Green/Blue)
     *
     * @method hex2rgb
     * @param hex {string} hex value to convert to rgb
     */
    rgbString2hex: function (rgb) {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
                ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
    },
    rgbaString2hexa: function (rgb) {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 5) ? "#" +
                ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[4], 10).toString(16)).slice(-2) : '';
    },

    rgb2hexo: function (rgb) {
        return "#" +
                ("0" + parseInt(rgb.red, 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb.green, 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb.blue, 10).toString(16)).slice(-2);
    },
    rgba2hexa: function (rgb) {
        return "#" +
                ("0" + parseInt(rgb.red, 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb.green, 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb.blue, 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb.alpha, 10).toString(16)).slice(-2);
    },
    /**
     * Takes two colors and interpolates them to a fractional value from 0 to 1.
     *
     * @method interpolateColor
     * @param color1 {Array} First color to interpolate from.
     * @param color2 {Array} Second color to interpolate to.
     * @param fraction {float} Amount between color1 and color2 where you want the interpolated color.
     */
    interpolateColor: function (color1, color2, fraction) {
        //keeps within range 0->1
        fraction = Math.min(fraction, 1.0);
        fraction = Math.max(fraction, 0.0);

        var red1 = color1.red,
                green1 = color1.green,
                blue1 = color1.blue,
                alpha1 = color1.alpha;

        var red2 = color2.red,
                green2 = color2.green,
                blue2 = color2.blue,
                alpha2 = color2.alpha;

        var red = this.interpolate(red1, red2, fraction);
        var green = this.interpolate(green1, green2, fraction);
        var blue = this.interpolate(blue1, blue2, fraction);
        var alpha = this.interpolate(alpha1, alpha2, fraction);


        red = Math.min(red, 255);
        red = Math.max(red, 0.0);
        green = Math.min(green, 255);
        green = Math.max(green, 0.0);
        blue = Math.min(blue, 255);
        blue = Math.max(blue, 0.0);
        alpha = Math.min(alpha, 255);
        alpha = Math.max(alpha, 0.0);

        return {'red': red, 'green': green, 'blue': blue, 'alpha': alpha};
    }, //interpolateColor

    gradient_fill: function (gradient) {
        var i, j, current_color_key, current_color_key_index, current_color_key_color_array, index_diff, fraction, color_array;
        var last_color_key_index = parseInt(gradient[0].index);
        var last_color_key_color_array = this.hexa2rgba(gradient[0].color);

        var new_gradient = [gradient[0]];
        for (i = 1; i < gradient.length; i++) {
            current_color_key = gradient[i];
            current_color_key_index = parseInt(current_color_key.index);
            current_color_key_color_array = this.hexa2rgba(current_color_key.color);
            index_diff = current_color_key_index - last_color_key_index;

            for (j = last_color_key_index + 1; j < current_color_key_index; j++) {
                fraction = (j - last_color_key_index) / index_diff;
                color_array = this.interpolateColor(last_color_key_color_array, current_color_key_color_array, fraction);
                new_gradient.push({color: this.rgba2hexa(color_array), index: '' + j + ''});
            }

            // Now attache the current color to the array
            new_gradient.push(current_color_key);
            last_color_key_index = current_color_key_index;
            last_color_key_color_array = current_color_key_color_array;
        }
        return new_gradient;
    } // gradient_fill
};